import { CommonModule } from "@angular/common";
import { Component, inject, OnInit } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { MatDividerModule } from "@angular/material/divider";
import { MatSelectModule } from "@angular/material/select";
import { Api } from "../../services/api";
import { Router } from "@angular/router";

@Component({
    selector: 'app-forecast',
    standalone: true,
    imports: [
    CommonModule,
    MatSelectModule,
    MatButtonModule,
    MatDividerModule,
    FormsModule,
    MatDialogModule,
  ],
  templateUrl: './forecast.html',
  styleUrls: ['./forecast.css'],
})
export class Forecast implements OnInit{

  private api = inject(Api);
  isLoading: boolean = false;
  public forecasts: any[] = [];
  public totales: any = [];

  selectedItem: string = 'todas';
  showRecentDropdown: boolean = false;
  errorMessage: string = '';
  expandedMonth: string | null = null;
  selectedExecutive: string | null = null; 
  selectedOpportunities: any[] = [];

  constructor(
    private router: Router
  ) {}

  ngOnInit(): void {
    this.generateDummyForecasts();
    this.getForecastReport();
  }

  getForecastReport(): void {
    this.api.showLoading();
    this.api.getForecastReport({ year: ""}).subscribe({
      next: (response: any) => {
        this.api.hideLoading();
        this.forecasts = response.data;
        this.totales = response.total_anual;
        console.log('Informe de pronóstico recibido:', this.forecasts);
      },
      error: (error: any) => {
        this.api.hideLoading();
        this.errorMessage = 'Error al obtener el informe de pronóstico.';
      }
    }); 
  }

 toggleRecentDropdown(): void {
    this.showRecentDropdown = !this.showRecentDropdown;
  }

  selectItem(key: string): void {
    this.selectedItem = key;
    this.showRecentDropdown = false;
  }

  generateDummyForecasts() {
    const meses = [
      'Enero 2025 de año fiscal',
      'Febrero 2025 de año fiscal',
      'Marzo 2025 de año fiscal',
      'Abril 2025 de año fiscal',
      'Mayo 2025 de año fiscal',
      'Junio 2025 de año fiscal',
      'Julio 2025 de año fiscal',
      'Agosto 2025 de año fiscal',
      'Septiembre 2025 de año fiscal',
      'Octubre 2025 de año fiscal',
      'Noviembre 2025 de año fiscal',
      'Diciembre 2025 de año fiscal'

    ];

    this.forecasts = meses.map((mes, i) => {
      const metas = 5000000 + i * 500000;
      const cerradas = 2200000 + i * 500000;
      const mejorCaso = 3000000 + i * 300000;
      const bajaProb = 1500000 + i * 150000;
      const totalPipeline = cerradas + mejorCaso + bajaProb;

      const ejecutivos = [
        { nombre: 'Tomás Leyton', metas, cerradas, mejorCaso, bajaProb, totalPipeline },
        { nombre: 'Luis Núñez', metas, cerradas, mejorCaso, bajaProb, totalPipeline },
        { nombre: 'Maximiliano Lisboa', metas, cerradas, mejorCaso, bajaProb, totalPipeline },
        { nombre: 'Oportunidades propias', metas, cerradas, mejorCaso, bajaProb, totalPipeline }
      ];

      return {
        mes,
        metas,
        cerradas,
        mejorCaso,
        bajaProb,
        totalPipeline,
        ejecutivos
      };
    });
  }

  sum(key: keyof typeof this.totales) {
    return this.forecasts.reduce((acc, item) => acc + (item[key] || 0), 0);
  }

  toggleMonth(mes: string) {
    this.expandedMonth = this.expandedMonth === mes ? null : mes;
  }

  showExecutiveDetails(exec: any) {
    this.api.showLoading();
    this.selectedExecutive = exec.ejecutivo;
    this.api.getOpportunityByEjecutivo({ ejecutivo_id: exec.ejecutivo_id }).subscribe({
      next: (response: any) => {
        this.api.hideLoading();
        this.selectedOpportunities = response.data;
        console.log('Oportunidades recibidas:', response.data);
      },
      error: (error: any) => {
        this.api.hideLoading();
      }
    });
  }

  showGraphicView() {
    this.router.navigate(['/forecast-graphic']);
  }
}